module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/success.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/slideCaptcha/assets/success.png
// module id = 1312
// module chunks = 438